import { render, staticRenderFns } from "./afterSaleManage.vue?vue&type=template&id=f8fdb0ae&scoped=true"
import script from "./afterSaleManage.vue?vue&type=script&lang=js"
export * from "./afterSaleManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fdb0ae",
  null
  
)

export default component.exports